import { msg } from '@lingui/core/macro';
import type { MessageDescriptor } from 'shared/i18n/i18n';

interface ICategory {
  label: MessageDescriptor;
  value: string;
}

export const categoryList: ICategory[] = [
  {
    label: msg`Обычные`,
    value: 'common',
  },
  {
    label: msg`Составные`,
    value: 'complex',
  },
  {
    label: msg`События`,
    value: 'events',
  },
  {
    label: msg`Карусель`,
    value: 'carousel',
  },
];
